/**
 * Can a timeline event anchor an improvement conversation? Only an agent-authored `case.message_sent` or
 * `case.comment_added` (IMP-BR-4): the API refuses any other event (a received message, a router
 * decision) with a 404, so the entry is not offered on them.
 */
export function isImprovableAgentMessage(eventType: string, actorKind: string | null | undefined): boolean {
  return (eventType === 'case.message_sent' || eventType === 'case.comment_added') && actorKind === 'agent';
}
